module.exports = __webpack_public_path__ + "img/full-06.9fc410a7.png";